@if (appStateAsContent === enumAsJson.PLAN_NAME) {
  <span>
    <h2>{{retrievedStateData}}</h2>
  </span>
}

@if (appStateAsContent === enumAsJson.PLAN_PRICE) {
  <span>
    <h2>{{retrievedStateData | currency }}</h2>
  </span>
}

@if (appStateAsContent === enumAsJson.PLAN_COUNTY) {
  <span>
    <h2>{{retrievedStateData}}</h2>
  </span>
}

@if (appStateAsContent === enumAsJson.PLAN_START_DATE) {
  <span>
    <h2>{{retrievedStateData}}</h2>
  </span>
}

@if (appStateAsContent === enumAsJson.PLAN_RATING_ENTITY) {
  <span>
    <h2>{{retrievedStateData}}</h2>
  </span>
}
